// extracted by mini-css-extract-plugin
module.exports = {"carouselEmpty":"up","buttonsWrapper":"uq"};